import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { _SalesOrderItemQuota } from "../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";

interface Props {
    idSalesOrder: number;
    salesOrderDate: any;
    idSelector?: number | null;
    label?: string;
    onChange: (value: any) => void;
}

export const SalesOrderItemAccountEditor = ({
    idSalesOrder,
    salesOrderDate,
    idSelector,
    label,
    onChange,
}: Props) => {
    const { instance, lista, setLista } = useDataBean(_SalesOrderItemQuota);
    const [id, setID] = useState<number | "">(idSelector ?? "");

    useEffect(() => {
        setID(idSelector ?? "");
    }, [idSelector]);

    useEffect(() => {
        if (idSalesOrder == null || salesOrderDate == null) {
            setLista([]);
            return;
        }

        instance.getSalesOrderItemAccountList(idSalesOrder, salesOrderDate).then((resp: any) => {
            setLista(resp ?? []);
        }).catch((err: any) => toast.error(err));
    }, [idSalesOrder, salesOrderDate]);

    const setValue = (value: string) => {
        if (value === "") {
            setID("");
            onChange(null);
            return;
        }

        const selectedID = Number(value);
        const selected = lista.find((item: any) => Number(item.DataBeanProperties.IDAccount) === selectedID);
        setID(selectedID);
        onChange(selected?.DataBeanProperties ?? null);
    };

    return (
        <>
            <label>{label ?? "Proveedor"}</label>
            <select className="form-select" value={id} onChange={(e) => setValue(e.target.value)}>
                <option value="">...</option>
                {lista.map((item: any, index: number) => (
                    <option key={index} value={item.DataBeanProperties.IDAccount}>
                        {item.DataBeanProperties.AccountNit} - {item.DataBeanProperties.AccountName}
                    </option>
                ))}
            </select>
        </>
    );
};
